// extracted by mini-css-extract-plugin
export default {"chatWrapper":"ChatHandler_chatWrapper__532Sn","assignButton":"ChatHandler_assignButton__HGBqs"};